export default __webpack_public_path__ + "0aac2cfd3c30e3e5aca99e43366a4a14.svg";